import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { Row } from "@xo-union/tk-component-grid";
import styles from "../../css/styles.css";

var FormRow = function FormRow(props) {
  return React.createElement(Row, _extends({
    className: styles.row
  }, props));
};

export default FormRow;